// @flow

import styled from "styled-components";
import { Flex } from "@src/common";
import { fullColorExtender } from "@src/common/colors";
import { spacingExtender } from "@src/common";

const RiskIndicatorDialog = styled.div`
  background-color: #fff;
  width: 100%;
`;

const RiskIndicatorsDialogHeader = styled(Flex)`
  flex: none;
  ${spacingExtender({ paddingV: 3 })};
  ${fullColorExtender};
`;

const RiskIndicatorsDialogBody = styled(Flex)`
  flex: none;
  flex-direction: column;
  ${spacingExtender({ padding: 3 })};
`;

export {
  RiskIndicatorDialog,
  RiskIndicatorsDialogBody,
  RiskIndicatorsDialogHeader
};



// WEBPACK FOOTER //
// ./src/containers/Assessment/ContentWrapper/Layouts/components/index.js